import React from "react";
import { Outlet } from "react-router-dom";

import type { LayoutProps } from "../types/app";

// eslint-disable-next-line no-empty-pattern
export function Layout({}: LayoutProps): React.ReactElement {
    return (
        <div>
            Layout here
            <main>
                <Outlet />
            </main>
        </div>
    );
}
